import { styled } from '@clickcease/cc-client-components-lib'

export const ProductsWrapper = styled('div', {
  display: 'flex',
  gap: '$5',
  flexGrow: 1,
})

export const SmallTitleEssentials = styled('span', {
  marginLeft: '$8',
  fontSize: '$md',
  fontWeight: '$l',
  '@media(max-width:1500px)': {
    marginLeft: 0,
  },
})
